import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KbOpenPositionModule } from './kb-open-position/kb-open-position.module';

@NgModule({
  imports: [CommonModule, KbOpenPositionModule],
})
export class KbPositionModule {}
